// utils
import { t } from 'i18next';
import * as yup from 'yup';

export const flexDrawerFilterSchema = yup.object().shape({
  employeeFlex: yup.boolean(),
  employeeUsedAsFlex: yup.boolean(),
  clusterPreference1: yup.boolean(),
  clusterPreference2: yup.boolean(),
  costCenterPreference1: yup.boolean(),
  costCenterPreference2: yup.boolean(),
  functionPreference1: yup.boolean(),
  functionPreference2: yup.boolean(),
  availabilityOnSameDay: yup.boolean(),
  availabilityOverlap: yup.boolean(),
  balanceHours: yup
    .number()
    .optional()
    .transform((value, originalValue) =>
      originalValue === '' ? undefined : value
    )
    .typeError(t('validation.mustBeNumber')),
  dutyOverlap: yup.boolean(),
  pool: yup.boolean(),
  qualified: yup.boolean()
});
